export enum Features {
  COVERAGE_CHECK = 'coverageCheckEnabled',
  EXPLORE_POLICY = 'explorePolicyEnabled',
  BROKER_PORTAL = 'brokerPortalEnabled',
  Q4E = 'q4eEnabled',
  FETCH_MY_POLICIES = 'fetchMyPoliciesEnabled',
  ADD_POLICY_POPUP = 'addPolicyPopupEnabled',
  LIFE_MS_ENABLED = 'lifeMSEnabled',
  MS_RESULTS_SEE_MORE = 'msResultsSeeMoreEnabled',
  HIDDEN_BROKER_MS = 'hiddenBrokerMS',
  APP_BANNER_ENABLED = 'appBannerEnabled',

  // Growthbook features
  SHOW_APP_BANNER = 'show-app-banner',

  CONVERSION_INITIO_ADS = 'conversion-initio-ads',
  CONVERSION_EXPERIMENT_AUTOSURE = 'conversion-experiment-autosure',
  CONVERSION_EXPERIMENT_AMP = 'conversion-experiment-amp',
  CONVERSION_EXPERIMENT_PINNACLE = 'conversion-experiment-pinnacle',
  CONVERSION_EXPERIMENT_QUASHED_SUPPORT_QUICK_BUY = 'conversion-quashed-support-quick-buy',
  CONVERSION_QUOTE_REQUEST = 'conversion-quote-request',
}
